export default {"src":"/_next/static/media/security.9a5537b0.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};